import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { NgSimpleSeoService } from './ng-simple-seo.service';

@Component({
  selector: "ng-simple-seo",
  template: ``,
  styles: [],
})
export class NgSimpleSeoComponent implements OnInit, OnChanges {
  @Input() public title ? = 'Angular Application';
  @Input() public description ?;
  @Input() public keywords ?;
  @Input() public twitterTitle?;
  @Input() public twitterDescription?;
  @Input() public twitterImage?;
  @Input() public twitterSite?;
  @Input() public twitterCreator?;
  @Input() public ogTitle?;
  @Input() public ogType?;
  @Input() public ogDescription?;
  @Input() public ogImage?;
  @Input() public ogUrl?;
  @Input() public ogSitename?;

  constructor(public ngSimpleSeoService: NgSimpleSeoService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.ngSimpleSeoService.set(
        this.title,
        this.keywords,
        this.description,
        this.twitterTitle,
        this.twitterDescription,
        this.twitterImage,
        this.twitterSite,
        this.twitterCreator,
        this.ogTitle,
        this.ogType,
        this.ogDescription,
        this.ogImage,
        this.ogUrl,
        this.ogSitename
      );
    }
  }

  ngOnInit(): void {
    this.ngSimpleSeoService.set(
      this.title,
      this.keywords,
      this.description,
      this.twitterTitle,
      this.twitterDescription,
      this.twitterImage,
      this.twitterSite,
      this.twitterCreator,
      this.ogTitle,
      this.ogType,
      this.ogDescription,
      this.ogImage,
      this.ogUrl,
      this.ogSitename
    );
  }
}
